import { requests } from '../helper/Agent';

export default class ManagementAPI {
  static getManagementTypes(role) {
    return requests.get(`/newManagementTypes/${role ? `?role=${role}` : ''}`);
  }
  static getManagementTypesById(id) {
    return requests.get(`/management-types/${id}`);  
  }
  static getRefinancingManagementTypes() {
    return requests.get('/RefinancingManagementTypes');
  }
  static getAllManagements(id) {
    return requests.get(`/managements/${id}/quotation`);
  }
  static getCaseManagements(id) {
    return requests.get(`/RefinancingManagements/case/${id}`);
  }
  static getManagementById(id) {
    return requests.get(`/managements/${id}`);
  }
  static createManagement(data) {
    return requests.post('/managements', data);
  }
  static createCaseManagement(data) {
    return requests.post('/RefinancingManagements', data);
  }
  static getContactTypes(id, role) {
    return requests.get(`/managementContacts/managementType/${id}${role ? `?role=${role}` : ''}`);
  }
  static getContactTypeById(id) {
    return requests.get(`/contact-types/${id}`);
  }
  static getTracking(id, role) {
    return requests.get(`/managementStatus/byContact/${id}${role ? `?role=${role}` : ''}`);
  }
  static getSearchState(id) {
    return requests.get(`/searchStates/getSearchState/${id}`);
  }
  static getCloseReasons(id) {
    return requests.get(`/closeReasons/searchState/${id}`);
  }
  static getTrackingById(id) {
    return requests.get(`/traking-statuses/${id}`);
  }
  static getOfferts() {
    return requests.get('/offerings');
  }
  static getReasons() {
    return requests.get('/reasons');
  }
  static createOffert(data) {
    return requests.post('/offerings', data);
  }
  static updateOffert(id, data) {
    return requests.put(`/offerings/${id}`, data);
  }
  static removeOffertById(id) {
    return requests.del(`/offerings/${id}`);
  }
}
